import { TButtonType } from '@r1-frontend/ui-react/components/buttons/button';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

const getTextColorByType = (type: TButtonType): COLORS => {
    switch (type) {
        case 'action':
        case 'primary':
        case 'accent':
            return COLORS.TextWhite;
        case 'secondary':
        case 'white':
        case 'ghost':
            return COLORS.TextPrimary;
    }
};

export default getTextColorByType;
